import {Injectable} from '@angular/core';
import {NavigationStart, Router} from '@angular/router';

import {BehaviorSubject, Observable, of, pipe, throwError} from 'rxjs';
import {map, catchError, finalize} from "rxjs/operators";


import {ApiService} from './api.service';
import {HttpErrorResponse} from "@angular/common/http";
import {VATParamItem} from '../../data/parameter-items';

import {logger} from '@retail-data-factory/rdf-angular-utils';

import {MessageService} from '@retail-data-factory/rdf-angular-messages';
import {TranslateService} from "@ngx-translate/core";
import {Presenter} from "../../api/internal/presenter/presenter";
import {SpinnerService} from "@retail-data-factory/rdf-angular-utils";
//import {MockService} from "../mock/mock.service";
import {emptyRdfServiceResponseError, IRdfServiceResponseError, IServiceResponse, Method} from "./response-interfaces";
import {ConfigurationManager} from "../../store/configuration-manager/configuration-manager";




@Injectable()
export class DataService {

  public appVersion;

  private isParamDataReady;
  private isFetchingInProgress = false;
  vatParamData: BehaviorSubject<Array<VATParamItem>> = new BehaviorSubject<Array<VATParamItem>>([]);

  constructor(
    private apiService: ApiService,
    private router: Router,
    private messageService: MessageService,
    private translate: TranslateService,
    private spinnerService: SpinnerService,
    public presenter: Presenter,
    private configurationManager: ConfigurationManager,
  //  private mockService: MockService
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (event.url === '/login') {
          this.reset();
        }
      }
    });
  }

  /*
  preparePostAuthData(): void {

    if (this.isParamDataReady || this.isFetchingInProgress) {
      return;
    }

    this.presenter.getPartners();
    if (this.configurationManager.configuration.theme !== 'auchan') {
      this.presenter.getAccounts();
    }

    this.userService.reloadLocalReportsName();

    this.isFetchingInProgress = true;
    this.presenter.resources$.subscribe((data) => {
      if (data.isLoaded) {
      }
    });


    const params = {};
    params['access_token'] = this.presenter.accessToken;

    this.apiService.get(this.configurationManager.getApiUrl('apiPlatformUrl') + '/users/token', params)
      .subscribe((data) => {
          const userInfo = data['report'];

          const profile = userInfo[0];
          this.userService.partyId = userInfo[0]["PartyID"];
          if (profile) {
            for (const key of Object.keys(profile)) {
              window.localStorage.setItem(key, profile[key]);
            }
          }
        }
      );


    logger.print('fetching dictionaries', 'paramData');
    const vatData = [
      {code: "0", name: "0%", value: 0},
      {code: "10", name: "10%", value: 0.10},
      {code: "20", name: "20%", value: 0.20}
    ];
    this.vatParamData.next(vatData);
    this.isParamDataReady = true;
    this.isFetchingInProgress = false;
  }
   */

  /**
   * Чтение файла версии. Если версия отличается от локальной, то делается принудительный рефреш и logout
   */
  readVersion() {
    return this.apiService.getAsString('./build.txt' + '?t=' + new Date().getTime()).pipe(
      map((result) => {
        console.log('version', result);
        if (this.appVersion !== undefined && this.appVersion !== result) {
          console.log(`Version has been changed! Old version = ${this.appVersion}, new version ${result}`);

          // const langTranslations = this.translate.translations[this.translate.currentLang];
          // const messageTranslation = langTranslations ? langTranslations.messages : null;
          // this.messageService.warnDialog.text1 = messageTranslation.availableNewVersion ? messageTranslation.availableNewVersion : 'Доступна новая версия';
          // this.messageService.warnDialog.onBtnClick = () => window.location.reload(true);
          // this.messageService.warnDialog.onClose = () => window.location.reload(true);
          // this.messageService.open('warn', 'Ок', '', 130);
          this.presenter.logout();//
          // this.userService.logout().catch(error => {
          //   console.log(`Error in logout`, error);
          // });
          window.location.reload(true);

        }
        this.appVersion = result;
      }),

      catchError((error: HttpErrorResponse) => {
        this.appVersion = 'no version';
        return throwError(error || 'backend server error');
      })
    );
  }

  reset() {
    this.vatParamData.next([]);
    this.isFetchingInProgress = false;
    this.isParamDataReady = false;
  }

  /**
   * Стандартная функция получения (GET) данных с сервиса. Возвращает IServiceResponse
   * @param url url запроса
   * @param requestParam параметры в header
   * @param checkParams массив полей, которые должны быть обязательны. Если в requestParam не будет полей, которые присутствуют в checkParams, то сервис вернет Observable null
   * @param hideSpinner показывать ли спинер в начале
   * @param hideSpinnerOnFinish скрывать ли спинер в конце вызова
   */
  getReportData(url: string, requestParam, checkParams?: Array<string>, hideSpinner = false, hideSpinnerOnFinish = true): Observable<IServiceResponse> {
    const method: Method = 'GET';

    //const partyId = this.presenter.authenticatedUserState.data.selectedPartyId;
    //if (!partyId) return null;
    // if (this.configurationManager.configuration.theme !== 'auchan') {
    //   const mock = this.mockService.mockGetData(url, this.presenter.authenticatedUserState.data.selectedPartyId, this.presenter.parametersState.selectedDatasourcePartyId);
    //   if (mock) return mock;
    // }


    const requestHeader = this.prepareHeader(requestParam);

    logger.print(`Data Reporting Service. Requesting ${url} report service with params:`, 'webService');
    console.log(requestParam);
    if (checkParams) {
      logger.print('Data Reporting Service. Checking parameters', 'webService');
      if (!this.checkReportParam(requestHeader, checkParams)) {
        logger.error('Data Reporting Service. Checking parameters failure');
        console.error(checkParams);
        return of(null);
      }
    }
    if (!hideSpinner) {
      this.spinnerService.show();
    }


    return this.apiService.get(url, requestHeader).pipe(
      map((result: IServiceResponse) => {
          return this.mapServiceResponse(result, 'GET', url, requestHeader);
        }
      ),
      catchError((error) => {
        return this.catchServiceResponse(error, 'GET', url, requestHeader);
      }),
      finalize(() => {
        if (hideSpinnerOnFinish) {
          this.spinnerService.hide();
        }
      })
    );
  }

  /**
   *
   * @param url
   * @param requestParam
   * @param checkParams
   * @param hideSpinner
   * @param hideSpinnerOnFinish
   */
  getData<T>(url: string, requestParam, checkParams?: Array<string>, hideSpinner = false, hideSpinnerOnFinish = true): Observable<T> {
    const partyId = this.presenter.authenticatedUserState.data.selectedPartyId;
    //if (!partyId) return null;
    // const mock = this.mockService.mockGetData(url, this.presenter.authenticatedUserState.data.selectedPartyId, this.presenter.parametersState.selectedDatasourcePartyId);
    // if (mock) return mock;


    const requestHeader = this.prepareHeader(requestParam);

    logger.print(`Data Reporting Service. Requesting ${url} report service with params:`, 'webService');
    console.log(requestParam);
    if (checkParams) {
      logger.print('Data Reporting Service. Checking parameters', 'webService');
      if (!this.checkReportParam(requestHeader, checkParams)) {
        logger.error('Data Reporting Service. Checking parameters failure');
        console.error(checkParams);
        return of(null);
      }
    }
    if (!hideSpinner) {
      this.spinnerService.show();
    }

    return this.apiService.get(url, requestHeader).pipe(
      map((result: T) => {
        logger.print(`Data Reporting Service. Service ${url} response:`, 'webService');
        console.log(result);
        if (result['Error']) {
          console.error(`Error in service ${url} response`);
          throw new Error(`Error in service ${url} response`);

        }
        if (!result['report']) {
          console.error('result.report is missing');
          throw new Error(`Error in service ${url} response result.report is missing.`);
        }
        return result;
      }),

      catchError((error) => {
        console.error(`Data Reporting Service. Service ${url} error:`, error);
        if (error.status === 401) {
          this.presenter.logout(); //проверить можно ли вставить return
        }
        return throwError(error);
        //return new Promise((resolve) => { resolve(error); });
      }),

      finalize(() => {
        if (hideSpinnerOnFinish) {
          this.spinnerService.hide();
        }
      })
    );

  }

  /**
   * Проверяет header на наличие обязательных параметров
   * @param requestHeader
   * @param keys
   */
  private checkReportParam(requestHeader, keys: Array<string>): boolean {
    let result = true;
    keys.forEach(key => {
      if (!requestHeader[key]) {
        logger.error(`Checking parameters failed for parameter ${key}`);
        result = false;
      }
    });
    return result;
  }


  /**
   * Вызов POST сервиса
   * @param url
   * @param requestParam
   * @param body
   */
  postData(url: string, requestParam, body): Observable<any> {
    const method: Method = 'POST';
    // if (this.configurationManager.configuration.theme !== 'auchan') {
    //   const partyId = this.presenter.authenticatedUserState.data.selectedPartyId;
    //   //if (!partyId) return null;
    //   const mock = this.mockService.mockPostData(url, this.presenter.authenticatedUserState.data.selectedPartyId, this.presenter.parametersState.selectedDatasourcePartyId);
    //   if (mock) return mock;
    // }

    const requestHeader = this.prepareHeader(requestParam);

    logger.print(`Data Reporting Service. Posting ${url} report service with params:`, 'webService');
    console.log(requestParam);
    this.spinnerService.show();

    return this.apiService.post(url, requestHeader, body).pipe(
      map((result: IServiceResponse) => {
          return this.mapServiceResponse(result, method, url, requestHeader);
        }
      ),
      catchError((error) => {
        return this.catchServiceResponse(error, method, url, requestHeader, body);
      }),

      finalize(() => this.spinnerService.hide())
    );

  }

  /**
   * Вызов PUT сервиса
   * @param url
   * @param requestParam
   * @param body
   */
  putData(url: string, requestParam, body): Observable<IServiceResponse> {
    const method: Method = 'PUT';
    // if (this.configurationManager.configuration.theme !== 'auchan' && this.configurationManager.configuration.theme !== 'portal') {
    //   const partyId = this.presenter.authenticatedUserState.data.selectedPartyId;
    //   if (!partyId) return null;
    //   const mock = this.mockService.mockPutData(url, this.presenter.authenticatedUserState.data.selectedPartyId, this.presenter.parametersState.selectedDatasourcePartyId);
    //   if (mock) return mock;
    // }
    const requestHeader = this.prepareHeader(requestParam);

    logger.print(`Data Reporting Service. Putting ${url} report service with params:`, 'webService');
    console.log(requestParam);
    this.spinnerService.show();

    return this.apiService.put(url, requestHeader, body).pipe(
      map((result: IServiceResponse) => {
          return this.mapServiceResponse(result, method, url, requestHeader);
        }
      ),
      catchError((error) => {
        return this.catchServiceResponse(error, method, url, requestHeader, body);
      }),

      finalize(() => this.spinnerService.hide())
    );

  }

  /**
   * Вызов PATCH сервиса
   * @param url
   * @param requestParam
   * @param body
   */
  patchData(url: string, requestParam, body): Observable<IServiceResponse> {
    const method: Method = 'PATCH';

    const requestHeader = this.prepareHeader(requestParam);

    logger.print(`Data Reporting Service. Putting ${url} report service with params:`, 'webService');
    console.log(requestParam);
    this.spinnerService.show();

    return this.apiService.patch(url, requestHeader, body).pipe(
      map((result: IServiceResponse) => {
          return this.mapServiceResponse(result, method, url, requestHeader);
        }
      ),
      catchError((error) => {
        return this.catchServiceResponse(error, method, url, requestHeader, body);
      }),

      finalize(() => this.spinnerService.hide())
    );

  }

  /**
   * Вызов DELETE сервиса
   * @param url
   * @param requestParam
   * @param body
   */
  deleteData(url: string, requestParam, body: string = ''): Observable<IServiceResponse> {
    const method: Method = 'DELETE';
    const partyId = this.presenter.authenticatedUserState.data.selectedPartyId;
    if (!partyId) return null;
    // const mock = this.mockService.mockDeleteData(url, this.presenter.authenticatedUserState.data.selectedPartyId, this.presenter.parametersState.selectedDatasourcePartyId);
    // if (mock) return mock;
    const requestHeader = this.prepareHeader(requestParam);

    logger.print(`Data Reporting Service. Deleting ${url} report service with params:`, 'webService');
    console.log(requestParam);
    this.spinnerService.show();
    return this.apiService.delete(url, requestHeader, body).pipe(
      map((result: IServiceResponse) => {
          return this.mapServiceResponse(result, method, url, requestHeader);
        }
      ),
      catchError((error) => {
        return this.catchServiceResponse(error, method, url, requestHeader);
      }),
      finalize(() => this.spinnerService.hide())
    );

  }

  /**
   * Функция подготовки заголовка запроса. Добавляет стандартные параметры в заголовк, такие как access_token, brand, lang etc.
   * Также производить кодирование параметра через encodeURI() и обрезает строки через trim()
   * @param requestParam - Параметры запроса
   */
  private prepareHeader(requestParam: object = {}): object {
    const requestHeader = {};
    for (const key of Object.keys(requestParam)) {
      requestHeader[key] = requestParam[key];
    }
    requestHeader['access_token'] = this.presenter.accessToken;

    if (this.presenter.parametersState.selectedDatasourcePartyId !== this.presenter.currentPartyId) {
      requestHeader['datasourcepartyid'] = this.presenter.parametersState.selectedDatasourcePartyId;
    }
    if (requestParam['datasourcepartyid']) {
      requestHeader['datasourcepartyid'] = requestParam['datasourcepartyid'];
    }
    if (this.presenter.workflowToken) {
      requestHeader['sso_token'] = this.presenter.workflowToken;
    }
    requestHeader['brand'] = this.getBrand();
    requestHeader['lang'] = 'RU';//this.translate.currentLang;
    //Кодируем все параметры в header для того, чтобы корректно передавались национальные буквы
    const newHeaderWOUnderscope = {};
    for (const k in requestHeader) {
      if (requestHeader.hasOwnProperty(k)) {
        if (typeof requestHeader[k] === 'string' || requestHeader[k] instanceof String) {
          // it's a string
          if (k==='password' || k==='old_password' || k==='new_password') {
            requestHeader[k] = encodeURIComponent(requestHeader[k].trim());
          }else{
            requestHeader[k] = encodeURI(requestHeader[k].trim());
          }

        }
        //Добавляем параметры с - вместо _ только для ашана
        if (this.configurationManager.theme ==='auchan') {
          if (k.includes('_')) {
            const kWOUnder = k.replace('_', '-');
            newHeaderWOUnderscope[kWOUnder] = requestHeader[k];
          }
        }
      }
    }
    for (const k in newHeaderWOUnderscope) {
      if (newHeaderWOUnderscope.hasOwnProperty(k)) {
        requestHeader[k] = newHeaderWOUnderscope[k];
      }
    }

    return requestHeader;
  }

  /**
   * Обработка ответа сервиса, и проверка на ошибки, которые возвращает сервис. Если сервис вернул ошибку, то выбросит исключение с типом IRdfServiceResponseError
   * @param response Ответ
   * @param method метод - GET PUT POST DELETE
   * @param url url запроса
   * @param headerRequest header запроса
   * @param body тело запроса. Применимо для PUT POST
   */
  private mapServiceResponse(response: IServiceResponse, method: Method, url: string, headerRequest: object, body: object = {}): IServiceResponse {
    if (response.Error !== 0) {
      const error: IRdfServiceResponseError = {
        ...emptyRdfServiceResponseError,
        errorCode: response.Error,
        msg: response.Msg,
        url: url,
        requestParams: headerRequest
      };
      console.error(error);
      throwError(error);
    }

    //Если сервис вернул в поле report null или undefined - то принудетельно мапим на пустой массив
    if (response['report'] === null || response['report'] === undefined) {
      response['report'] = [];
    }
    //Если сервис вернул в поле report не массив, то выкидываем ошибку
    if (Array.isArray(response['report'])) {
      const result: IServiceResponse = response;
      return result;
    } else {
      const error: IRdfServiceResponseError = {
        ...emptyRdfServiceResponseError,
        errorCode: -1,
        msg: 'service response error. Report is not Array',
        url: url,
        requestParams: headerRequest,
        requestBody: body
      };
      console.error(error);
      throwError(error);
    }
    return null;
  }

  /**
   * Обработчик ошибок сервиса
   * @param error ошибка
   * @param method метод - GET PUT POST DELETE
   * @param url url запроса
   * @param headerRequest header запроса
   * @param body тело запроса. Применимо для PUT POST
   */
  private catchServiceResponse(error, method: Method, url: string, headerRequest: object, body?: object): Observable<never> {
    console.error(`Data Reporting Service. Method ${method} service ${url} error:`, error);

    if (error.status === 401) {
      this.presenter.logout();
    }
    if (error.status === 403) {
      this.router.navigate(['main']).catch(e=>console.error(e));
    }

    const err: IRdfServiceResponseError = this.apiService.mapHttpErrorToRdfError(method, error, url, headerRequest, body);
    return throwError(err);

  }


  getBrand(): string {
    let result = this.configurationManager.configuration.theme;
    if (result === 'renessans') {
      result = 'renaissance';
    }
    if (result === 'portal') {
      result = 'redfactory';
    }
    return result;
  }

}
